import AccountBoxIcon from "@mui/icons-material/AccountBox";

import ApartmentIcon from "@mui/icons-material/Apartment";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import HandshakeIcon from "@mui/icons-material/Handshake";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import DraftsIcon from '@mui/icons-material/Drafts';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';

import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import i18n from "../../../i18n";
import MiniDrawer from "../MiniDrawer";

import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { useAuth } from "../../../context/auth";
import hasUserPermission from "../../../helpers/userPermissions";
import { USER_ROLES } from "../../../helpers/constants";

import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

export const NAVIGATION_DRAWER_TYPE_ALL = "all";
export const NAVIGATION_DRAWER_TYPE_EXAMPLE = "example";
export const NAVIGATION_DRAWER_TYPE_LEADS = "leads";
export const NAVIGATION_DRAWER_TYPE_CLIENTS = "clients";
export const NAVIGATION_DRAWER_TYPE_PERSON_REPOSITORY = "persons";
export const NAVIGATION_DRAWER_TYPE_CONTACTS = "contacts";
export const NAVIGATION_DRAWER_TYPE_PRODUCTS = "products";
export const NAVIGATION_DRAWER_TYPE_TASKS = "tasks";
export const NAVIGATION_DRAWER_TYPE_OFFERS = "offers";
export const NAVIGATION_DRAWER_TYPE_AGREEMENTS = "agreements";
export const NAVIGATION_DRAWER_TYPE_INVESTMENT_DOCS = "investment_docs";
export const NAVIGATION_DRAWER_TYPE_FINANCIAL_PANEL = 'financial-panel';

const topDrawerActionIcons = [
    {
        label: i18n.t("drawer.navigation_drawer.leads_page"),
        icon: <PersonOutlineIcon />,
        link: "/leads/",
        pageName: "leads",
        drawerType: NAVIGATION_DRAWER_TYPE_LEADS,
    },
    {
        label: i18n.t("drawer.navigation_drawer.clients_page"),
        icon: <AccountBoxIcon />,
        link: "/customers/",
        pageName: "customers",
        drawerType: NAVIGATION_DRAWER_TYPE_CLIENTS,
    },
    {
        label: i18n.t("drawer.navigation_drawer.tasks_page"),
        icon: <CalendarMonthIcon />,
        link: "/tasks/",
        pageName: "tasks",
        drawerType: NAVIGATION_DRAWER_TYPE_TASKS,
    },
    {
        label: i18n.t("drawer.navigation_drawer.agreements_page"),
        icon: <HandshakeIcon />,
        link: "/agreements/",
        pageName: "agreements",
        drawerType: NAVIGATION_DRAWER_TYPE_AGREEMENTS,
    },
    {
        label: i18n.t("drawer.navigation_drawer.offers_page"),
        icon: <LocalOfferIcon />,
        link: "/offers/",
        pageName: "offers",
        drawerType: NAVIGATION_DRAWER_TYPE_TASKS,
    },
    {
        label: i18n.t("drawer.navigation_drawer.bookings_page"),
        icon: <CalendarTodayIcon />,
        link: "/bookings/",
        pageName: "bookings",
        // permissionList: [IS_ADMIN],
        drawerType: NAVIGATION_DRAWER_TYPE_TASKS,
    },
    {
        label: i18n.t("drawer.navigation_drawer.person_repository_page"),
        icon: <Diversity3Icon />,
        link: "/persons/",
        pageName: "persons",
        drawerType: NAVIGATION_DRAWER_TYPE_PERSON_REPOSITORY,
    },
    {
        label: i18n.t("drawer.navigation_drawer.contacts_page"),
        icon: <LocalPhoneIcon />,
        link: "/contacts/",
        pageName: "contacts",
        drawerType: NAVIGATION_DRAWER_TYPE_CONTACTS,
    },
    {
        label: i18n.t("drawer.navigation_drawer.products_page"),
        icon: <ApartmentIcon />,
        link: "/products/",
        pageName: "products",
        drawerType: NAVIGATION_DRAWER_TYPE_PRODUCTS,
    },
    {
        label: i18n.t("drawer.navigation_drawer.investment_docs"),
        icon: <DraftsIcon />,
        link: "/investment-docs/",
        pageName: "investment-docs",
        drawerType: NAVIGATION_DRAWER_TYPE_INVESTMENT_DOCS,
        permissionList: [USER_ROLES.ADMIN, USER_ROLES.SALES_LEGAL, USER_ROLES.SALES, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_MARKETING]
    },
    {
        label: i18n.t("drawer.navigation_drawer.bankings"),
        icon: <DescriptionOutlinedIcon />,
        link: "/financial-panel/banking/",
        pageName: "bankings",
        drawerType: NAVIGATION_DRAWER_TYPE_FINANCIAL_PANEL,
        permissionList: [USER_ROLES.SALES_LEGAL, USER_ROLES.ADMIN, USER_ROLES.INVESTMENT_DPI, USER_ROLES.ACCOUNT]
    },
    {
        label: i18n.t("drawer.navigation_drawer.transfers"),
        icon: <AttachMoneyIcon />,
        link: "/financial-panel/transfer/investment_bills/",
        pageName: "transfers",
        drawerType: NAVIGATION_DRAWER_TYPE_FINANCIAL_PANEL,
        permissionList: [USER_ROLES.SALES_LEGAL, USER_ROLES.ADMIN, USER_ROLES.INVESTMENT_DPI, USER_ROLES.ACCOUNT]
    },
    {
        label: i18n.t("drawer.navigation_drawer.invoicing"),
        icon: <ReceiptLongIcon />,
        link: "/financial-panel/invoicing/investment_bills/",
        pageName: "invoicing",
        drawerType: NAVIGATION_DRAWER_TYPE_FINANCIAL_PANEL,
        permissionList: [USER_ROLES.SALES_LEGAL, USER_ROLES.ADMIN, USER_ROLES.INVESTMENT_DPI, USER_ROLES.ACCOUNT]
    },
    {
        label: i18n.t("drawer.navigation_drawer.agreements_page"),
        icon: <HandshakeIcon />,
        link: "/financial-panel/agreements/",
        pageName: "financial-panel-agreements",
        drawerType: NAVIGATION_DRAWER_TYPE_FINANCIAL_PANEL,
        permissionList: [USER_ROLES.SALES_LEGAL, USER_ROLES.ADMIN, USER_ROLES.INVESTMENT_DPI, USER_ROLES.ACCOUNT]
    },
    {
        label: i18n.t("drawer.navigation_drawer.investment_passport"),
        icon: <MapsHomeWorkIcon />,
        // link: `${window._env_.MY_HOME_FRONTEND_URL}investments/`,
        link: "/to_myhome_investment/",
        drawerType: NAVIGATION_DRAWER_TYPE_INVESTMENT_DOCS,
        permissionList: [USER_ROLES.ADMIN, USER_ROLES.SALES_LEGAL]
    },
    {
        label: i18n.t("drawer.navigation_drawer.agreemnt_overdue_payments_page"),
        icon: <MoneyOffIcon />,
        link: "/agreement-overdue-payments/",
        pageName: "agreement-overdue-payments",
        drawerType: NAVIGATION_DRAWER_TYPE_AGREEMENTS,
    },
];
const middleDrawerActionIcons = [];
const bottomDrawerActionIcons = [];

function NavigationDrawer(props) {
    const { user } = useAuth();
    const location = useLocation();

    const getDrawerActionIconsContent = (drawerActionIcons) => {
        return drawerActionIcons
            .filter((drawerActionIcon) => {
                const permissionList = drawerActionIcon.permissionList || [];
                return (
                    hasUserPermission(permissionList, user) &&
                    (drawerActionIcon.drawerType === NAVIGATION_DRAWER_TYPE_ALL ||
                        drawerActionIcon.drawerType === props.drawerType ||
                        props.extraDrawerTypes.includes(drawerActionIcon.drawerType))
                );
            })
            .map((drawerActionIcon) => {
                const { pageName, link, permissionList, ...rest } = drawerActionIcon;
                return {
                    ...rest,
                    callback: () => window.location.replace(link),
                    isActive: location.pathname === link,
                };
            });
    };

    const topDrawerIcons = getDrawerActionIconsContent(topDrawerActionIcons);
    const middleDrawerIcons = getDrawerActionIconsContent(middleDrawerActionIcons);
    const bottomDrawerIcons = getDrawerActionIconsContent(bottomDrawerActionIcons);
    return (
        <MiniDrawer
            initialOpen={true}
            topDrawerActionIcons={topDrawerIcons}
            showTopDrawerActionIcons={topDrawerIcons.length > 0}
            middleDrawerActionIcons={middleDrawerIcons}
            showMiddleDrawerActionIcons={middleDrawerIcons.length > 0}
            bottomDrawerActionIcons={bottomDrawerIcons}
            showBottomDrawerActionIcons={bottomDrawerIcons.length > 0}
            drawerType={props.drawerType}
        >
            {props.children}
        </MiniDrawer>
    );
}

export default NavigationDrawer;

NavigationDrawer.propTypes = {
    pageName: PropTypes.string,
    drawerType: PropTypes.oneOf([NAVIGATION_DRAWER_TYPE_ALL, NAVIGATION_DRAWER_TYPE_EXAMPLE]),
    extraDrawerTypes: PropTypes.array,
};

NavigationDrawer.defaultProps = {
    drawerType: NAVIGATION_DRAWER_TYPE_EXAMPLE,
    extraDrawerTypes: [],
};
